var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("before"),(!!_vm.currentComponent)?_c(_vm.currentComponent,_vm._b({tag:"component"},'component',_vm.viewData,false)):_c('div',{staticClass:"zj-errmsg"},[_c('span',[_vm._v(_vm._s(_vm.errmsg))])]),_vm._t("default"),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }